<template>
  <div>
    <KeyValue
      :caption="$t('Suppliers.OnSite')"
      data-qa="supplier-on-site"
      :value="is_on_site"/>
  </div>
</template>

<script>
import KeyValue from 'components/common/KeyValue.vue'
import moment from 'moment'

export default {
  name: 'supplierOnSite',
  props: {
    supplier: Object,
  },
  computed: {
    is_on_site() {
      let date = moment.preciseDiff(this.supplier.registrationDate, moment().format(), true),
        years = date.years ?  moment()._locale._relativeTime.MM(date.years, null , 'yy' ) : '',
        months = date.months ?  moment()._locale._relativeTime.MM(date.months, null , 'MM' ) : '',
        days = date.days ?  moment()._locale._relativeTime.MM(date.days, null , 'dd' ) : ''
      date = `${years} ${months} ${days}`
      return date
    },
  },
  components: {
    KeyValue,
  }
}
</script>
